// Central configuration for all professional information.
// Edit the values here to update the entire landing page.

export const professional = {
  name: "Tatiana Andrade",
  title: "Enfermeira Estomaterapeuta",
  shortTitle: "Estomaterapeuta",
  brandEssence:
    "acolhimento com ciência e humanidade no conforto da sua casa.",

  whatsappUrl:
    "https://api.whatsapp.com/send/?phone=5585992132014&text=Ol%C3%A1%2C+gostaria+de+agendar+uma+avalia%C3%A7%C3%A3o%21&type=phone_number&app_absent=0",
  instagramUrl: "https://www.instagram.com/tatianaandradeestomaterapeuta/",
  instagramHandle: "@tatianaandradeestomaterapeuta",

  cta: {
    primary: "Agendar uma avaliação",
    secondary: "Conheça meu trabalho",
    final: "Agendar minha avaliação",
  },

  heroImage:
    "https://storage.helloreaddy.io/project_files/0e78cd91-0f30-4ecf-9165-3cae8e50e9cf/8ed5384b-e35e-41b9-bf0f-8412ede2f25d_compressed_Imagem-do-Codex-7-de-set.-de-2026-17_46_063.webp",
  aboutImage:
    "https://storage.helloreaddy.io/project_files/0e78cd91-0f30-4ecf-9165-3cae8e50e9cf/24c23ef9-241f-44ce-8fcc-2d40c65a80c7_compressed_Imagem-do-Codex-7-de-set.-de-2026-18_22_29.webp",
  laserImage:
    "https://storage.helloreaddy.io/project_files/0e78cd91-0f30-4ecf-9165-3cae8e50e9cf/bc0dfbd4-6478-4170-9f79-60a4b46ea89c_compressed_Imagem-do-Codex-7-de-set.-de-2026-17_51_46.webp",
  homeCareImage:
    "https://storage.helloreaddy.io/project_files/0e78cd91-0f30-4ecf-9165-3cae8e50e9cf/b88bd066-eca6-4026-9b80-d403783dc7ae_compressed_Imagem-do-Codex-7-de-set.-de-2026-18_07_07.webp",
};

export const navLinks = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Especialidades", href: "#especialidades" },
  { label: "Laserterapia", href: "#laserterapia" },
  { label: "Home Care", href: "#homecare" },
  { label: "Instagram", href: "#instagram" },
  { label: "Dúvidas", href: "#duvidas" },
];

export const footerLinks = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Estomaterapia", href: "#especialidades" },
  { label: "Laserterapia", href: "#laserterapia" },
  { label: "Home Care", href: "#homecare" },
  { label: "Instagram", href: "#instagram" },
  { label: "Dúvidas", href: "#duvidas" },
  { label: "Contato", href: "#duvidas" },
];

export type CareArea = {
  index: string;
  title: string;
  copy: string;
  note?: string;
  cta: string;
  href: string;
};

export const careAreas: CareArea[] = [
  {
    index: "01",
    title: "Feridas & Cicatrização",
    copy: "Uma ferida que não evolui como esperado merece uma avaliação especializada.",
    cta: "Quero uma avaliação",
    href: professional.whatsappUrl,
  },
  {
    index: "02",
    title: "Dor & Laserterapia",
    copy: "Conviver com dor não precisa simplesmente se tornar parte da rotina.",
    note:
      "A Laserterapia pode integrar protocolos individualizados quando indicada.",
    cta: "Conhecer a Laserterapia",
    href: "#laserterapia",
  },
  {
    index: "03",
    title: "Cuidados Materno-Infantis",
    copy: "Algumas fases exigem um olhar ainda mais cuidadoso.",
    cta: "Conhecer os cuidados",
    href: "#especialidades",
  },
  {
    index: "04",
    title: "Home Care",
    copy: "Cuidado especializado no conforto da sua casa.",
    cta: "Solicitar atendimento",
    href: "#homecare",
  },
];

export type ProtocolGroup = {
  title: string;
  items: string[];
};

export const protocolGroups: ProtocolGroup[] = [
  {
    title: "Dor / Musculoesquelético",
    items: [
      "Lombalgia",
      "Fibromialgia",
      "Artrose",
      "Artrite",
      "Hérnia de disco",
      "Cervicalgia",
      "Fascite plantar",
      "Tendinite",
      "Epicondilite",
      "DTM",
      "Cefaleia",
    ],
  },
  {
    title: "Cuidados e Cicatrização",
    items: ["Cicatrizes", "Fissuras", "Mastite", "Hemorroidas"],
  },
  {
    title: "Materno-Infantil",
    items: [
      "Coto umbilical",
      "Cólicas",
      "Cuidados relacionados a vacinas",
      "Assaduras",
      "DAI",
      "Sapinho",
    ],
  },
  {
    title: "Outros protocolos",
    items: [
      "Rinite",
      "Sinusite",
      "Amigdalite",
      "Bronquiolite",
      "Bebê chiador",
      "Tosse",
      "Asma",
      "Bronquite",
      "Herpes labial",
      "Candidíase",
      "Mão-pé-boca",
      "Disfunção gastrointestinal",
      "Distúrbios do sono",
      "Ansiedade",
      "TDAH",
      "TEA",
      "Depressão",
      "Aumento de performance",
    ],
  },
];

export type JourneyStep = {
  index: string;
  title: string;
  copy: string;
};

export const journeySteps: JourneyStep[] = [
  {
    index: "01",
    title: "Entre em contato",
    copy: "Converse pelo WhatsApp.",
  },
  {
    index: "02",
    title: "Agendamento",
    copy: "Definição da melhor possibilidade de atendimento.",
  },
  {
    index: "03",
    title: "Avaliação individualizada",
    copy: "Conhecimento da necessidade e histórico.",
  },
  {
    index: "04",
    title: "Plano de cuidado",
    copy: "Definição da abordagem adequada.",
  },
  {
    index: "05",
    title: "Acompanhamento",
    copy: "Acompanhamento da evolução conforme cada necessidade.",
  },
];

export type FaqItem = {
  q: string;
  a: string;
};

export const faqItems: FaqItem[] = [
  {
    q: "O que faz uma Enfermeira Estomaterapeuta?",
    a: "A Enfermeira Estomaterapeuta é uma profissional especializada no cuidado de feridas, estomias e incontinências, atuando também na promoção da cicatrização e do conforto. Ela realiza avaliação individualizada e pode propor recursos terapêuticos e protocolos adequados a cada necessidade, sempre dentro de suas competências profissionais.",
  },
  {
    q: "Quando devo procurar uma Estomaterapeuta?",
    a: "Quando houver uma ferida que demora a cicatrizar, desconforto ou dor que impacta a rotina, ou necessidade de orientação especializada em cuidados com a pele, estomias ou cicatrização. A avaliação profissional é o primeiro passo para entender cada situação.",
  },
  {
    q: "Como funciona a primeira avaliação?",
    a: "A avaliação começa pela escuta: conhecer a sua necessidade, seu histórico e o que você está vivenciando. A partir disso, é possível definir, junto com você, a melhor abordagem e um plano de cuidado individualizado, sempre com comunicação clara e respeitosa.",
  },
  {
    q: "O que é Laserterapia?",
    a: "A Laserterapia é um recurso terapêutico que utiliza luz em comprimentos de onda específicos. Ela pode auxiliar em protocolos de cicatrização, alívio da dor e cuidados com a pele, quando indicada após avaliação profissional. Não substitui o acompanhamento médico.",
  },
  {
    q: "Todo paciente pode realizar Laserterapia?",
    a: "Não. A Laserterapia tem indicações e contraindicações que precisam ser avaliadas por um profissional habilitado. Por isso, cada caso é analisado individualmente antes de qualquer recomendação.",
  },
  {
    q: "Como funciona o atendimento Home Care?",
    a: "O atendimento Home Care leva o cuidado especializado até a sua casa, priorizando comodidade, acolhimento e segurança. É uma alternativa para pessoas com mobilidade reduzida, idosos, pacientes em recuperação ou que preferem ser acompanhados no conforto do lar.",
  },
  {
    q: "Como faço para agendar?",
    a: "Basta clicar no botão de agendamento ou conversar pelo WhatsApp. A partir da sua mensagem, definimos juntos a melhor possibilidade de atendimento para a sua necessidade.",
  },
];

// Professional registration fields — fill with real data (do not invent).
export const professionalInfo = {
  council: "",
  address: "",
  city: "",
  phone: "",
  email: "",
};

// Testimonials — leave empty to hide the section automatically.
export const testimonials: {
  quote: string;
  name: string;
  context: string;
}[] = [];